import { BSS_BREAKDOWN, CLIENTS } from "@/data/mock";

export default function AdminBSS() {
  return (
    <div className="space-y-10">
      <div>
        <div className="eyebrow">// BSS Engine</div>
        <h1 className="display-lg text-silver-50 mt-2">Brand Strength Scoring</h1>
        <p className="text-silver-300 mt-3 max-w-2xl">
          Weighted scoring across 6 categories. Gate at 75 unlocks Phase 2 advertising. Trust Sprint auto-proposes when any client sits below 70 for more than 14 days.
        </p>
      </div>

      <div className="grid gap-6 lg:grid-cols-2">
        <div className="panel p-6">
          <div className="eyebrow">// Category weights</div>
          <div className="mt-5 space-y-4">
            {BSS_BREAKDOWN.map((b) => (
              <div key={b.category}>
                <div className="flex justify-between text-sm text-silver-100">
                  <span>{b.category}</span>
                  <span className="font-mono text-silver-300">weight {(b.weight * 100).toFixed(0)}%</span>
                </div>
                <div className="mt-1 h-2 rounded-full bg-ink-700 overflow-hidden">
                  <div className="h-full bg-gradient-to-r from-brand-blueDeep to-brand-cyan" style={{ width: `${b.weight * 100 * 4}%` }} />
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="panel-hi p-6">
          <div className="eyebrow">// Gate rule</div>
          <div className="mt-4 font-display font-extrabold text-6xl text-brand-blue">75</div>
          <p className="text-silver-200 mt-3">Minimum BSS required to unlock Phase 2 (paid media, scale content, expanded SEO).</p>
          <div className="hairline my-6" />
          <div className="grid grid-cols-3 gap-3 text-center">
            <div><div className="font-display font-bold text-2xl text-brand-blue">{CLIENTS.filter(c => c.bss >= 75).length}</div><div className="eyebrow">// Cleared</div></div>
            <div><div className="font-display font-bold text-2xl text-silver-100">{CLIENTS.filter(c => c.bss >= 60 && c.bss < 75).length}</div><div className="eyebrow">// Approaching</div></div>
            <div><div className="font-display font-bold text-2xl text-brand-red">{CLIENTS.filter(c => c.bss < 60).length}</div><div className="eyebrow">// Trust Sprint</div></div>
          </div>
        </div>
      </div>

      <div className="panel p-6">
        <div className="eyebrow">// Client scores</div>
        <div className="mt-4 space-y-3">
          {CLIENTS.map((c) => (
            <div key={c.id} className="flex items-center gap-4">
              <div className="w-40 font-display text-silver-50 text-sm">{c.name}</div>
              <div className="flex-1 h-3 rounded-full bg-ink-700 overflow-hidden relative">
                <div
                  className={`absolute inset-y-0 left-0 ${c.bss >= 75 ? "bg-brand-blue" : c.bss >= 60 ? "bg-silver-200" : "bg-brand-red"}`}
                  style={{ width: `${c.bss}%` }}
                />
                <div className="absolute inset-y-0" style={{ left: "75%", width: "1px", background: "#FF3B5C" }} />
              </div>
              <div className={`w-12 text-right font-mono ${c.bss >= 75 ? "text-brand-blue" : c.bss >= 60 ? "text-silver-100" : "text-brand-red"}`}>{c.bss}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
